'use client';

import { fmtDateVar } from '@/lib/utils/fmtDateVar';
import {
  useEntrySearchQuery,
  useEntrySearchStore,
  useFilter,
  type Variables,
} from '@liquorice/next-search';
import { DateRange } from '@mui/x-date-pickers-pro/models';
import { Dayjs } from 'dayjs';
import React from 'react';

export const useEventTimeFilter = () => {
  const [value, setValue] = React.useState<DateRange<Dayjs> | undefined>(undefined);

  const autoSubmit = useEntrySearchStore((s) => s.autoSubmit);
  const { setValue: setStoreValue } = useEntrySearchStore((s) => s);
  const { submit } = useEntrySearchQuery();

  const ascFieldHandle = 'combinedTimeAsc';
  const descFieldHandle = 'combinedTimeDesc';

  const filterCallback = React.useCallback(
    (variables: Variables) => {
      const nextVariables = {
        ...variables,
      } satisfies Variables;

      if (value) {
        const [startDate, endDate] = value;

        const startStr = startDate
          ? startDate.hour(1).minute(0).second(0).format('YYYY-MM-DD HH:mm')
          : undefined;
        const endStr = endDate
          ? endDate.hour(23).minute(0).second(0).format('YYYY-MM-DD HH:mm')
          : undefined;

        const formattedStartDate =
          fmtDateVar({ start: startStr, format: 'YYYY-MM-DD HH:mm' }) ?? [];
        const formattedEndDate = fmtDateVar({ end: endStr, format: 'YYYY-MM-DD HH:mm' }) ?? [];

        nextVariables[ascFieldHandle] = formattedEndDate;
        nextVariables[descFieldHandle] = formattedStartDate;
      }

      return nextVariables;
    },
    [value]
  );

  useFilter({
    id: ascFieldHandle,
    callback: filterCallback,
  });

  useFilter({
    id: descFieldHandle,
    callback: filterCallback,
  });

  const handleChange = (newValue: DateRange<Dayjs>) => {
    // console.log('handleChange', place);
    setValue(newValue);

    const [startDate, endDate] = newValue;

    const startStr = startDate
      ? startDate.hour(1).minute(0).second(0).format('YYYY-MM-DD HH:mm')
      : undefined;
    const endStr = endDate
      ? endDate.hour(23).minute(0).second(0).format('YYYY-MM-DD HH:mm')
      : undefined;

    const formattedStartDate = fmtDateVar({ start: startStr, format: 'YYYY-MM-DD HH:mm' }) ?? [];
    const formattedEndDate = fmtDateVar({ end: endStr, format: 'YYYY-MM-DD HH:mm' }) ?? [];

    setStoreValue(ascFieldHandle, formattedEndDate);
    setStoreValue(descFieldHandle, formattedStartDate);

    if (autoSubmit) {
      submit();
    }
  };

  return {
    value,
    handleChange,
  };
};
